/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_mode_words = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words`)
};

const es_rv_mode_words = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palabras`)
};

const de_rv_mode_words = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wörter`)
};

const nl_rv_mode_words = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woorden`)
};

const fr_rv_mode_words = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mots`)
};

const it_rv_mode_words = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parole`)
};

const pt_br2_rv_mode_words = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavras`)
};

const pt_rv_mode_words = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavras`)
};

const ja_rv_mode_words = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語`)
};

const zh_rv_mode_words = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单词`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_mode_words = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_mode_words(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_mode_words", locale)
	if (locale === "en") return en_rv_mode_words(inputs)
	if (locale === "es") return es_rv_mode_words(inputs)
	if (locale === "de") return de_rv_mode_words(inputs)
	if (locale === "nl") return nl_rv_mode_words(inputs)
	if (locale === "fr") return fr_rv_mode_words(inputs)
	if (locale === "it") return it_rv_mode_words(inputs)
	if (locale === "pt-BR") return pt_br2_rv_mode_words(inputs)
	if (locale === "pt") return pt_rv_mode_words(inputs)
	if (locale === "ja") return ja_rv_mode_words(inputs)
	return zh_rv_mode_words(inputs)
};